import axios from 'axios';
var axiosInstance = axios.create();
axiosInstance.interceptors.request.use(function (config) {
    var switchUser = localStorage.getItem('senso-impersonate-user');
    if (switchUser) {
        config.headers['X-Switch-User'] = switchUser;
    }
    if (config.method === 'patch') {
        config.headers["Content-Type"] = 'application/merge-patch+json';
    }
    return config;
}, function (error) {
    // Do something with request error
    return Promise.reject(error);
});
export default axiosInstance;
